<template>
<div class="p-4 back_princ">

<div class=" d-flex justify-content-center var_color">
 <i class="fas fa-file-signature fa-4x"></i>
</div>

<div class=" d-flex justify-content-center var_color mb-4">
 <h2 class="font-weight-lighter pr-3">Devis</h2>
</div>




<div class=" row p-4">

            <!-- Earnings (Monthly) Card Example -->
            <div class="col">
              <div class="btn card border border-light shadow h-100 py-2" @click="click_new">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-secondary text-uppercase">Nouveau Devis</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-plus-square fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>


</div>





<div class=" row p-4">

            <!-- Earnings (Monthly) Card Example -->
            <div class="col">
              <div class="btn card border border-light shadow h-100 py-2" @click="click_brouillon">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="font-weight-bold text-secondary  text-uppercase "> Devis <span class="text-warning">( Brouillons ) </span></div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-edit fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Earnings (Annual) Card Example -->
            <div class="col">
              <div class="btn card border border-light shadow h-100 py-2"  @click="click_valid">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-secondary  text-uppercase"> Devis <span class="text-success">( Archivés ) </span></div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-check-square fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

</div>




  </div>
</template>

<script>
export default {

 methods:{
       click_new()
      {
                      //goto first page:
                    this.$router.push({ 
                        name: 'bnDevis'

                    });
      },
      click_brouillon()
      {
                       //goto first page:
                    this.$router.push({ 
                        name: 'listBnDevis'

                    });
      },
      click_valid()
      {
                        //goto first page:
                    this.$router.push({ 
                        name: 'listBnDevisVal'

                    });
      },


 }
}
</script>
<style scoped>
.back_princ{
  background: #eff7fa;
}
.var_color{
  color: #2faaa5;
}
.text_org{
  color: green;
}
</style>